import './WhoWeHire.scss';
import Img1 from './img11.jpg';
import Img2 from './img22.jpg';
import Img3 from './img66.jpg';
import Img4 from './img44.jpg';
import Img5 from './img55.jpg';
import Img7 from './img77.jpg';

const WhoWeHire = ({ withTitle = true }) => {
  return (
    <div className='whoWeHire'>
      {withTitle && <span className='whoWeHireTitle'>Who we hire</span>}
      {withTitle && (
        <span className='workWithUsText'>
          At NextDeavor, we help companies of every size find the talent they need to grow. From technical innovators to
          people-first leaders, here are the areas we specialize in:
        </span>
      )}
      <div className='whoWeHireItems'>
        <div className='whoWeHireItem'>
          <div className='whoWeHireItemContent'>
            <div className='whoWeHireItemImage'>
              <img src={Img1} />
            </div>
            <div className='whoWeHireItemTitle'>Technology & Engineering</div>
          </div>
          <div className='whoWeHireItemTags'>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              Software & Full-Stack Engineers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              Data & AI
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              Cloud & DevOps
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              Cybersecurity
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              Robotics & Automation
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              Embedded/IoT
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              SOC/Hardware
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#3ABC83', background: '#E4F5ED' }}>
              QA & Test
            </span>
          </div>
        </div>

        <div className='whoWeHireItem'>
          <div className='whoWeHireItemContent'>
            <div className='whoWeHireItemImage'>
              <img src={Img2} />
            </div>
            <div className='whoWeHireItemTitle'>Data, Finance & Operations</div>
          </div>
          <div className='whoWeHireItemTags'>
            <span className='whoWeHireItemTag' style={{ color: '#6768BE', background: '#EFEFFF' }}>
              Accountants
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#6768BE', background: '#EFEFFF' }}>
              Financial Analysts
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#6768BE', background: '#EFEFFF' }}>
              FP&A, Controllers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#6768BE', background: '#EFEFFF' }}>
              Tax & Audit
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#6768BE', background: '#EFEFFF' }}>
              Treasury
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#6768BE', background: '#EFEFFF' }}>
              Finance Systems
            </span>
          </div>
        </div>

        <div className='whoWeHireItem'>
          <div className='whoWeHireItemContent'>
            <div className='whoWeHireItemImage'>
              <img src={Img3} />
            </div>
            <div className='whoWeHireItemTitle'>Marketing & Creative</div>
          </div>
          <div className='whoWeHireItemTags'>
            <span className='whoWeHireItemTag' style={{ color: '#E574A5', background: '#FFEEF2' }}>
              Marketing Managers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E574A5', background: '#FFEEF2' }}>
              Growth & Digital
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E574A5', background: '#FFEEF2' }}>
              Content & Brand
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E574A5', background: '#FFEEF2' }}>
              Product Marketing
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E574A5', background: '#FFEEF2' }}>
              UX/UI Design
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E574A5', background: '#FFEEF2' }}>
              Creative & Copy
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E574A5', background: '#FFEEF2' }}>
              Brand & Communications
            </span>
          </div>
        </div>

        <div className='whoWeHireItem'>
          <div className='whoWeHireItemContent'>
            <div className='whoWeHireItemImage'>
              <img src={Img7} />
            </div>
            <div className='whoWeHireItemTitle'>Customer Experience & Sales</div>
          </div>
          <div className='whoWeHireItemTags'>
            <span className='whoWeHireItemTag' style={{ color: '#609330', background: '#EFF7E4' }}>
              Account Executives
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#609330', background: '#EFF7E4' }}>
              Sales Managers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#609330', background: '#EFF7E4' }}>
              SDRs/BDRs
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#609330', background: '#EFF7E4' }}>
              Customer Success
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#609330', background: '#EFF7E4' }}>
              Sales Engineers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#609330', background: '#EFF7E4' }}>
              Revenue Operations
            </span>
          </div>
        </div>

        <div className='whoWeHireItem'>
          <div className='whoWeHireItemContent'>
            <div className='whoWeHireItemImage'>
              <img src={Img4} />
            </div>
            <div className='whoWeHireItemTitle'>HR, Admin & People</div>
          </div>
          <div className='whoWeHireItemTags'>
            <span className='whoWeHireItemTag' style={{ color: '#75A0CD', background: '#EEF6FF' }}>
              HR Managers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#75A0CD', background: '#EEF6FF' }}>
              Talent Acquisition
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#75A0CD', background: '#EEF6FF' }}>
              People Operations
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#75A0CD', background: '#EEF6FF' }}>
              HR Business Partners
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#75A0CD', background: '#EEF6FF' }}>
              DEI
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#75A0CD', background: '#EEF6FF' }}>
              L&D
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#75A0CD', background: '#EEF6FF' }}>
              Employee Experience
            </span>
          </div>
        </div>

        <div className='whoWeHireItem'>
          <div className='whoWeHireItemContent'>
            <div className='whoWeHireItemImage'>
              <img src={Img5} />
            </div>
            <div className='whoWeHireItemTitle'>Manufacturing, Industrial & Field Roles</div>
          </div>
          <div className='whoWeHireItemTags'>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Production Associates
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Material Handlers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Technicians
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Plant & Operations Managers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Manufacturing & Process Engineers
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Quality, Maintenance
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Field Service
            </span>
            <span className='whoWeHireItemTag' style={{ color: '#E58974', background: '#FFF5EE' }}>
              Supply Chain & Logistics
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeHire;
